/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { RESALE_ACTIVE_BOX } from "../graphql/resaleActiveBox.mutate";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IResaleActiveBoxMethods extends IPluginMethodMap {
  resaleActiveBox(args: any): Promise<any>;
}

export class ResaleActiveBoxService implements IAgentPlugin {
  readonly methods: IResaleActiveBoxMethods;

  constructor() {
    this.methods = {
      resaleActiveBox: this.resaleActiveBox.bind(this),
    };
  }

  async resaleActiveBox(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const boxId = args?.filter?._id || args?.id || args?._id;
        const res = await client.mutate({
          mutation: RESALE_ACTIVE_BOX,
          variables: {
            filter: {
              _id: boxId,
            },
            reason: args?.reason || "Resale to new user",
            deleteIfFullyPaid: args?.deleteIfFullyPaid ?? true,
            deleteReferral: args?.deleteReferral ?? true,
            data: {
              email: args?.data?.email ?? args?.email,
              firstName: args?.data?.firstName ?? args?.firstName ?? "",
              lastName: args?.data?.lastName ?? args?.lastName ?? "",
              reason: args?.data?.reason ?? args?.reason ?? "Resale of deleted box via admin dashboard",
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return {
            ...res?.data?.resaleActiveBox,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
